import { Box, ColorOptions, FileSelector, Icon, LoaderNew, Spacer, Text, TextNew } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { isEmpty, isEmptyObject } from '@jfs/utils'
import { useState } from 'react'
import XlsxPopulate from 'xlsx-populate'
import { useStores } from '../../data/store'
import { MessageTypes } from '../../utils'

const { REACT_APP_ENDPOINT = '' } = window?._env_

const BulkPayoutCmsUpdate = () => {
  const [filename, setFilename] = useState('')
  const [loading, setLoading] = useState(false)
  const [txns, setTxns] = useState<any>([])
  const [inputKeys, setInputkeys] = useState<String[]>([])
  const [wsdata, setWsData] = useState<XlsxPopulate.Workbook>()

  const { setMessage, bulkUpdate } = useStores((store) => ({
    setMessage: store.message.setMessage,
    bulkUpdate: store.payoutCms.bulkUpdate,
  }))

  const [bulkUpdateLoading, setBulkUpdateLoading] = useState(false)
  const isValidEntry = (obj: any) => {
    const values = Object.values(obj)
    const isValidColumns = values?.filter((item: string) => !isEmpty(item))?.length > 0
    return !isEmptyObject(obj) && isValidColumns
  }

  const columns = ['Payout Sequence Number', 'CMS Number', 'MID', 'Settlement Date', 'Status']
  const readExcel = async (file: any, name: string) => {
    if (!file) {
      setFilename(name)
      setWsData(undefined)
      return
    }
    setLoading(true)
    const readPromise = new Promise((resolve, reject) => {
      XlsxPopulate.fromDataAsync(file)
        .then(function (workbook) {
          setFilename(name)
          setWsData(workbook)
          const sheet = workbook.sheet(0)
          const rows = sheet._rows
          const keys: string[] = []
          const values: any = []
          rows.forEach((row: any, rowIndex: number) => {
            const obj: any = {}
            for (let i = 1; i < row._cells.length; i++) {
              if (rowIndex === 1) {
                keys.push(`${row._cells[i]?.value() ?? ''}`)
              } else {
                const key = keys[i - 1]
                let val = `${String(row._cells[i]?.value() ?? '')?.trim()}`
                if (key === 'Settlement Date') {
                  val = val?.replaceAll('-', '/')
                }
                obj[key] = val
              }
            }
            isValidEntry(obj) && values.push(obj)
          })
          const isExcelInvalid = columns.some((item) => !keys.includes(item))
          if (!isExcelInvalid) {
            setTxns(values)
            setInputkeys(keys)
            resolve(values)
          } else {
            reject('Invalid File')
          }
        })
        .catch(() => {
          reject('Invalid File')
        })
    })
    try {
      await readPromise
    } catch (e) {
      setWsData(undefined)
      setFilename('')
      setMessage(e, MessageTypes.ERROR)
    }
    setLoading(false)
  }

  const onBulkUpload = async (apiCall: any, loaderFunc: (b: boolean) => void, fileName: string) => {
    loaderFunc(true)
    const errorData: any[] = await apiCall(txns)
    loaderFunc(false)

    let transformedData: any = []
    const modifiedMidData = JSON.parse(JSON.stringify(txns))
    modifiedMidData?.forEach((item) => {
      inputKeys?.forEach((key) => {
        if (item[key as keyof typeof item] === undefined) {
          item[key as keyof typeof item] = ''
        }
      })
    })
    transformedData = errorData.map((item) => [item.status, item.message, item.code])
    transformedData.splice(0, 0, ['Result', 'Message', 'Error code'])
    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const data: any = []
      data.push([...inputKeys, ...transformedData[0]])
      modifiedMidData.map((item: any, index: number) => {
        data.push([...Object.values(item), ...transformedData[index + 1]])
      })

      workbook.sheet(0)?.cell('A1').value(data)

      const blob = await workbook.outputAsync({
        type: 'blob',
      })
      var url = window.URL.createObjectURL(blob as Blob)
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = `Result_${fileName}.xlsx`
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }

  const handlePress = () => {
    onBulkUpload(bulkUpdate, setBulkUpdateLoading, filename)
  }

  return (
    <Box flex={1} bg="WHITE" align="center" overflow={'auto'} pv={16}>
      <Text title={'Bulk CMS Update'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      <Spacer direction="vertical" size={16} />
      <FileSelector
        innerCompTitle={`Please upload Bulk CMS Update file`}
        innnerCompSubtitle={'Browse your file'}
        onFileSelect={readExcel}
        fileType=".xlsx"
        filename={filename}
      />
      <Spacer size={16} />
      <ButtonNew
        disabled={!wsdata}
        paddingVertical={16}
        title={'Update'}
        isLoading={bulkUpdateLoading}
        type="primary"
        onPress={handlePress}
      />
      <Spacer size={32} />
      <a
        href={`${REACT_APP_ENDPOINT}/sample_cms_update.xlsx`}
        style={{ textDecoration: 'none' }}
        rel="noopener noreferrer"
        target="_blank">
        <Box flexDirection={'row'} align={'center'}>
          <Icon id={'DOWNLOAD'} color={'PRIMARY'} />
          <Spacer size={8} direction={'horizontal'} />
          <TextNew fontFamily={'jiotype-medium'} fontSize={14} color={'PRIMARY'}>
            {'Sample File'}
          </TextNew>
        </Box>
      </a>
      {loading && (
        <Box
          backgroundColor={'TRANSPARENT'}
          position={'absolute'}
          left={0}
          right={0}
          top={0}
          bottom={0}
          alignItems="center"
          justify="center">
          <LoaderNew color={'PRIMARY'} type="large" />
        </Box>
      )}
    </Box>
  )
}

export default BulkPayoutCmsUpdate
